export const toLowerCase = (value?: string | null) => {
  if (!value) return "";
  return value.toLowerCase();
};
